import React from 'react';

function SystemPage() {
  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">System</h1>
        <p className="text-gray-600">System configuration and maintenance</p>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <p className="text-gray-500">System management coming soon...</p>
      </div>
    </div>
  );
}

export default SystemPage;
